import './WizardCategories.css';
import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
/* import { useLocation, useHistory } from 'react-router-dom'; */

import clsx from 'clsx';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CategoryDetails from './CategoryDetails';
import { canUseDOM, getColorByTheme, getPageThemeColors, get, injectImageResolution, getDictionaryItem } from '../../utils';
import { ReactComponent as ChevronDownIcon } from '../../resources/icons/chevron-down-big.svg';
import { ReactComponent as ChevronDetDownIcon } from '../../resources/icons/chevron-down-24-px.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { checkJssError } from '../../utils/checkJssError';
;
const WizardCategories = _ref => {
  let {
    fields,
    params
  } = _ref;
  const detailsWrapper = useRef(null);
  const [desktopDetailsWrapperHeight, setDesktopDetailsWrapperHeight] = useState('0px');
  const [additionalOpenRecountFlag, setAdditionalOpenRecountFlag] = useState(false);
  const [isVdsite, setIsVdsite] = useState(true);
  const [expandedIds, setExpandedIds] = useState([]);
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  /* const pageEditing: boolean = Boolean(sitecoreContext && sitecoreContext.pageEditing); */
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const title = get(fields, 'data.item.title.jss.value');
  const shortDescription = get(fields, 'data.item.shortDescription.jss.value');
  const cards = get(fields, 'data.item.categories.items', []);

  /* Dictionaries vals*/
  const dictionary = get(fields, 'data.dictionary');
  const backToTopTerm = getDictionaryItem(dictionary, 'backToTop') || '';
  const showCarousel = useMemo(() => {
    return cards.length > 5;
  }, [cards]);
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const isMobile = useMemo(() => {
    return !actualSSR && canUseDOM && window.matchMedia(`(max-width: 991px)`).matches;
  }, [actualSSR]);
  const detailsAsAccordeon = useMemo(() => {
    return isMobile && !showCarousel;
  }, [isMobile, showCarousel]);
  /* Page setttings */
  const isDetSite = get(params, 'RenderingStyle') === 'DDA';

  /* Theme setttings */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const variables = BackgroundColorHex ? {
    '--m134-category-wizard-background-color': BackgroundColorHex,
    '--m134-category-wizard-background-active-color': ActiveColorHex,
    '--m134-category-wizard-color': ColorHex
  } : {
    '--m134-category-wizard-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m134-category-wizard-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m134-category-wizard-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  /* End Theme setttings */

  let countHeight;
  if (canUseDOM) {
    countHeight = throttle(() => {
      if (detailsWrapper.current) {
        const visibleDetailsBlock = detailsWrapper.current.querySelector('.js--details-visible');
        if (visibleDetailsBlock) {
          setDesktopDetailsWrapperHeight(getComputedStyle(visibleDetailsBlock).getPropertyValue('--wc-details-height'));
        }
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', countHeight);
    }
    return () => {
      window.removeEventListener('resize', countHeight);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeight, 300);
  }, [sitecoreContext.selectedFontSize]);
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(() => {
    if (canUseDOM && (showCarousel || !isMobile) && detailsWrapper.current) {
      if (expandedIds.length) {
        const visibleDetailsBlock = detailsWrapper.current.querySelector('.js--details-visible');
        setDesktopDetailsWrapperHeight(getComputedStyle(visibleDetailsBlock).getPropertyValue('--wc-details-height'));
      } else {
        setDesktopDetailsWrapperHeight('0px');
      }
    }
  }, [expandedIds, isMobile]);
  useEffect(() => {
    if (additionalOpenRecountFlag && canUseDOM) {
      setTimeout(countHeight, 100);
    }
  }, [additionalOpenRecountFlag]);

  /* const loadMore = (): void => {}; */

  const categoryClickHandlerAccordeon = categoryId => () => {
    scroolToElement(categoryId);
    if (!additionalOpenRecountFlag) {
      setAdditionalOpenRecountFlag(true);
    }
    if (expandedIds.includes(categoryId)) {
      setExpandedIds(expandedIds.filter(id => id !== categoryId));
    } else {
      setExpandedIds([categoryId, ...expandedIds]);
    }
  };
  const categoryClickHandler = categoryId => () => {
    scroolToElement(categoryId);
    if (!additionalOpenRecountFlag) {
      setAdditionalOpenRecountFlag(true);
    }
    setExpandedIds(expandedIds[0] === categoryId ? [] : [categoryId]);
  };
  const backToTopClickHandler = e => {
    const carousel = e.target.closest('.wc-container-wrapper--in-carousel');
    const stickyNav = document.querySelector(isVdsite ? '.main-nav' : '.dot-site-header--fixed');
    const navHeight = stickyNav ? stickyNav.offsetHeight : 0;
    if (carousel) {
      setExpandedIds([]);
      window.scrollTo(0, carousel.getBoundingClientRect().top + window.scrollY - navHeight);
    }
  };
  const wizardWrapperRef = useRef(null);
  const scroolToElement = id => {
    if (wizardWrapperRef.current) {
      window.scrollTo({
        top: window.scrollY + wizardWrapperRef.current.querySelector(`.wc__list-item--${id}`).getBoundingClientRect().top,
        behavior: 'smooth'
      });
    }
  };
  const renderItems = state => {
    const startItemToShow = state ? state.currentSlide : null;
    const endItemToShow = state ? state.currentSlide + state.slidesToShow - 1 : null;
    return cards.filter(card => get(card, 'title.jss.value') && get(card, 'title.jss.value') !== '$name').map((card, index) => {
      const title = get(card, 'title.jss.value');
      const highlightTitle = get(card, 'highlightTitle.jss.value');
      const highlightSubTitle = get(card, 'highlightSubtitle.jss.value');
      const image = get(card, 'image.jss.value');
      const itemVisible = !state || typeof startItemToShow === 'number' && typeof endItemToShow === 'number' && index >= startItemToShow && index <= endItemToShow;
      return /*#__PURE__*/React.createElement("div", {
        className: `wc__list-item wc__list-item--${card.id}`,
        key: card.id
      }, /*#__PURE__*/React.createElement("div", {
        className: clsx('wc__card', {
          'wc__card--expanded': expandedIds.includes(card.id)
        })
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: itemVisible ? 0 : -1,
        className: "wc__card-frame",
        onClick: detailsAsAccordeon ? categoryClickHandlerAccordeon(card.id) : categoryClickHandler(card.id),
        onKeyPress: event => {
          if (event.key === 'Enter' || event.key === 'NumpadEnter' || event.which === 32) {
            event.preventDefault();
            if (detailsAsAccordeon) {
              categoryClickHandlerAccordeon(card.id)();
            } else {
              categoryClickHandler(card.id)();
            }
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "wc__card__analytics-trigger",
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), title);
        }
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        hover: true,
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 1441px)",
        srcSet: injectImageResolution(image.src, 1420, 800)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: injectImageResolution(image.src, 1096, 800)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 568px)",
        srcSet: injectImageResolution(image.src, 1850, 400)
      }), /*#__PURE__*/React.createElement("img", {
        className: "wc__card-image",
        src: injectImageResolution(image.src, 1040, 400),
        alt: image.alt
      }))), /*#__PURE__*/React.createElement("h4", {
        className: "wc__card__title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "wc__card__highlight",
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), `${highlightTitle}`);
        }
      }, highlightTitle && /*#__PURE__*/React.createElement("h6", {
        className: "wc__card__highlight-title"
      }, highlightTitle), highlightSubTitle && /*#__PURE__*/React.createElement("p", {
        className: "wc__card__highlight-subtitle"
      }, /*#__PURE__*/React.createElement("strong", null, highlightSubTitle))), /*#__PURE__*/React.createElement("span", {
        className: "wc__card__opener",
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), `${highlightTitle}`);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "wc__card__opener-disc"
      }), isDetSite ? /*#__PURE__*/React.createElement(ChevronDetDownIcon, {
        className: "icon"
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        className: "icon"
      })))), !showCarousel && isMobile && /*#__PURE__*/React.createElement(CategoryDetails, {
        cardsToShow: expandedIds,
        cardsProps: card,
        rtl: rtl,
        toTopTerm: backToTopTerm,
        additionalRecount: additionalOpenRecountFlag,
        isMobile: isMobile,
        isDetSite: isDetSite,
        analytics: {
          eventsAnalytics,
          params
        }
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    cssVars: variables,
    isCarousel: showCarousel,
    isMobile: isMobile,
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    ref: wizardWrapperRef,
    className: `wc__items-${cards.length > 5 ? 5 : cards.length}`
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "h3 wc__title"
  }, title), (isMobile || !showCarousel) && shortDescription && /*#__PURE__*/React.createElement("h5", {
    className: "wc__short-description"
  }, shortDescription), !showCarousel && isMobile && /*#__PURE__*/React.createElement("div", {
    className: "wc__list-wrapper"
  }, renderItems()), !showCarousel && !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wc__list-wrapper row"
  }, renderItems())), showCarousel && /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-start justify-content-between"
    }, shortDescription && /*#__PURE__*/React.createElement("h5", {
      className: "wc__short-description"
    }, shortDescription), /*#__PURE__*/React.createElement("div", {
      className: "wc__carousel-controls"
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNavAnalytics'], params)), true, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextNavAnalytics'], params)), true, false, null, isDetSite))), renderCarousel(renderItems(state), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 992
          },
          items: 5
        },
        mobile: {
          breakpoint: {
            max: 991,
            min: 0
          },
          items: 1
        }
      },
      beforeChange: () => {
        setExpandedIds([]);
      }
    }), renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params)), [], isDetSite));
  }), (showCarousel || !isMobile) && /*#__PURE__*/React.createElement("div", {
    className: clsx("wc__details-wrapper-visibility", {
      "wc__details-wrapper-visibility--visible": expandedIds[0]
    }),
    style: {
      '--details-wrapper-height': desktopDetailsWrapperHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc__details-wrapper-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc__details-wrapper",
    ref: detailsWrapper
  }, cards.filter(card => get(card, 'title.jss.value') && get(card, 'title.jss.value') !== '$name').map(card => /*#__PURE__*/React.createElement(CategoryDetails, {
    key: card.id,
    cardsToShow: expandedIds,
    cardsProps: card,
    rtl: rtl,
    toTopTerm: backToTopTerm,
    additionalRecount: additionalOpenRecountFlag,
    isMobile: isMobile,
    inCarousel: showCarousel,
    backToTopHandler: backToTopClickHandler,
    isDetSite: isDetSite,
    analytics: {
      eventsAnalytics,
      params
    }
  })))))));
};
const ValidatedComponent = props => checkJssError(props, WizardCategories);
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    cssVars,
    isCarousel,
    isMobile,
    isDetSite
  } = _ref3;
  const commonStyles = isDetSite ? "ciop7t8" : "c1tryd9v";
  const ltrStyles = isDetSite ? "l8zz39z" : "l1gecc5d";
  const rtlStyles = isDetSite ? "r1mznouo" : "rei7l75";
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'wc-container-wrapper--in-carousel': isCarousel,
      'wc-container-wrapper--desktop': !isMobile
    })
  }, /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: clsx(commonStyles, rtl ? rtlStyles : ltrStyles),
    style: cssVars
  }, children));
};
export default ValidatedComponent;